module.exports = __webpack_public_path__ + "img/company_bg.7692f00c.png";